import { render, staticRenderFns } from "./SendQuick.vue?vue&type=template&id=4f59ee83"
import script from "./SendQuick.vue?vue&type=script&lang=js"
export * from "./SendQuick.vue?vue&type=script&lang=js"
import style0 from "./SendQuick.vue?vue&type=style&index=0&id=4f59ee83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports